module.exports = __webpack_public_path__ + "img/error-cat.73fcdaa6.gif";